<template>
  <div class="l-edit-dialog-box" style="padding-top:0">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading">
      <!-- <el-divider content-position="left">基础信息</el-divider> -->
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="消防柜名称" prop="site_name">
            <el-input v-model="form_data.site_name" autocomplete="off" placeholder="请输入名称" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="编码" prop="abbreviation">
            <el-input v-model="form_data.site_code" autocomplete="off" placeholder="请输入编码" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="12">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入缩写" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="24">
          <el-form-item label="地址" prop="site_address">
            <el-input v-model="form_data.site_address" autocomplete="off" placeholder="请输入地址" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>
        
        <!-- <el-col :span="12">
          <el-form-item label="物业公司" prop="site_administrator">
            <el-input v-model="form_data.site_administrator" autocomplete="off" placeholder="请输入物业公司" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col> -->
        
        <el-col :span="12">
          <el-form-item label="负责人" prop="site_charger">
            <el-input v-model="form_data.site_charger" autocomplete="off" placeholder="请输入负责人" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="负责人电话" prop="site_charger_tel">
            <el-input v-model="form_data.site_charger_tel" autocomplete="off" placeholder="请输入负责人电话" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>
        
        <!-- <el-col :span="12">
          <el-form-item label="联系人" prop="site_contact">
            <el-input v-model="form_data.site_contact" autocomplete="off" placeholder="请输入联系人" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="联系人电话" prop="site_contact_tel">
            <el-input v-model="form_data.site_contact_tel" autocomplete="off" placeholder="请输入联系人电话" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col> -->
        
        <!-- 根据选着角色来判断-->
        <!-- <el-col :span="12">
          <el-form-item label="管理街道" prop="place_type_ids">
            <el-select v-model="form_data.place_type_ids" multiple placeholder="请选择街道(可多选)" clearable @change="changes" :disabled="place_type_list.length==0 ||isInfo ||role_highest_id.indexOf(form_data.role_ids)>=0|| form_data.role_ids == ''">
              <el-option v-for="item in place_type_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->

        <el-col :span="12">
          <el-form-item label="所属模块类型" prop="moduler_id">
            <el-select v-model="form_data.moduler_id" placeholder="请选择模块类型" :disabled="moduler_list.length==0 ||this.$props.id!=null ">
              <el-option v-for="item in moduler_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="选择归属管理部门" prop="org_id">
            <el-cascader v-model="form_data.org_id" :options="org_tree" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="选择消防柜模板" prop="cabinet_template_id">
            <el-select v-model="form_data.cabinet_template_id" placeholder="请选择消防柜模板" @change="changeTemplate(form_data.cabinet_template_id)" :disabled="template_list.length==0 ||this.$props.id!=null ">
              <el-option v-for="item in template_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="检查状态" prop="site_state_id">
            <el-select v-model="form_data.site_state_id" placeholder="请选择消防柜状态" :disabled="site_state_list.length==0 ||this.$props.id!=null ">
              <el-option v-for="item in site_state_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="选择要复制的消防柜" prop="cabinet_id">
            <el-select v-model="form_data.cabinet_id" placeholder="请选择要复制的消防柜" :disabled="cabinet_list.length==0 ||this.$props.id!=null ">
              <el-option v-for="item in cabinet_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="启用状态" prop="is_active">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        
        <el-col :span="24">
          <el-form-item label="正面照片" prop="photo">
            <l-upload-img method="cabinetManage_uploadPhoto"  accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,'site_photo')" :preview-url="site_photo_preview" :disabled="isInfo">
            </l-upload-img>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import { randomWord } from "@/utils/Fuc";
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
export default {
  name: "l-user-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
     org_id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false, //页面是否加载中

      show_org_id_select: false,
      is_editable: false,
      org_tree: [],
      role_list: [],
      community_list: [],
      moduler_list: [],
      role_highest_id: [],
      street_list: [],
      site_state_list: [],
      template_list: [],
      cabinet_list: [],
      //
      company_list: [],
      // department_list:[],
      moduler_id:1,
      defaultProps: {
        children: "children",
        label: "name",
      },
      //表单数据
      form_data: {
        site_code: "",
        site_name: "",
        abbreviation: "",
        site_address: "",
        site_charger: "",
        site_charger_tel: "",
        site_contact: "",
        site_contact_tel: "",

        org_id:"",
        moduler_id: 1,
        site_state_id: null,
        template_id: 0,
        is_active: 1,
      },
      //表单验证规则
      rules: {
        site_name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "change",
          },
        ],
        org_id: [
          {
            required: true,
            message: "请选择归属管理部门",
            trigger: "change",
          },
        ],
        moduler_id: [
          {
            required: true,
            message: "请选择所属模块类型",
            trigger: "change",
          },
        ],
        site_state_id: [
          {
            type: "number",
            required: true,
            message: "请选择检查状态",
            trigger: "change",
          },
        ],
        template_id: [
          {
            type: "number",
            required: true,
            message: "请选择消防柜模板",
            trigger: "change",
          },
        ],

      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },

  methods: {
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      this.form_data[field] = res.data.site_photo_url;
      this[field + "_preview"] = res.data.site_photo;
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //获取数据
    getData() {
        this.loading = true;
        if (!this.hasId) {
            this.$_invoke("cabinetManage_getCabinetAddData", {
                org_id: this.$props.org_id,
                id: this.$props.id,
            })
            .then((ret) => {
                // console.log(ret)
                // this.community_list = ret.community_list;
                // this.place_type_list = ret.place_type_list;
                // this.street_list = ret.street_list;
                // this.role_highest_id = ret.role_highest_id;
                // this.role_list = ret.role_list;

                this.moduler_list = ret.moduler_list;
                this.org_tree = ret.tree_node;
                this.site_state_list = ret.site_state;
                this.template_list = ret.template_list;
            })
            .finally(() => {
                this.loading = false;
            });
        } else {
            this.$_invoke("cabinetManage_getCabinetUpdateData", {
                org_id: this.$props.org_id,
                id: this.$props.id,
            })
            .then((ret) => {
                // console.log(ret)
                // this.community_list = ret.community_list;
                // this.place_type_list = ret.place_type_list;
                // this.street_list = ret.street_list;
                // this.role_highest_id = ret.role_highest_id;
                // this.role_list = ret.role_list;

                this.form_data = ret.data[0];

                this.moduler_list = ret.moduler_list;
                this.org_tree = ret.tree_node;
                this.site_state_list = ret.site_state;
                this.template_list = ret.template_list;
            })
            .finally(() => {
                this.loading = false;
            });
        }
      
      // if (this.hasId) {
      //   this.$_invoke("cabinetManage_getUpdateData", {
      //     id: this.$props.id,
      //     // pid_ids: this.form_data.street_ids
      //   })
      //     .then((ret) => {
      //       // console.log(ret)
      //       this.community_list = ret.community_list;
      //       this.place_type_list = ret.place_type_list;
      //       this.street_list = ret.street_list;
      //       this.role_highest_id = ret.role_highest_id;
      //       this.role_list = ret.role_list;
      //       this.form_data = ret.data;
      //       this.moduler_list = ret.moduler_list;
      //       this.org_tree = ret.tree_node;
      //       this.site_state_list = ret.site_state;
      //       this.template_list = ret.template_state;
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // } else {
      //   this.$_invoke("cabinetManage_getAddData", {
      //     org_id:this.$props.org_id
      //   })
      //     .then((ret) => {
      //       this.role_list = ret.role_list;
      //       this.community_list = ret.community_list;
      //       this.role_highest_id = ret.role_highest_id;
      //       this.street_list = ret.street_list;
      //       this.moduler_list = ret.moduler_list;
      //       this.org_tree = ret.tree_node;
      //       this.site_state_list = ret.site_state;
      //       this.template_list = ret.template_state;
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // }
    },
    
    changeTemplate(template_id) {
        let sel_template_id = template_id;
        
        this.loading = true;
        this.$_invoke(`cabinetManage_getCabinetListByTemplateId`, {sel_template_id }).then((ret) => {
            this.cabinet_list = ret.cabinet_list;
        }).finally(() => {
          this.loading = false;
        });
    },

    //生成随机密码
    randomWord() {
      this.form_data.pwd = randomWord(true, 6, 6);
    },

    //点击复制链接
    copy(e) {
       console.log(e.text);
      this.$_msg.success("复制成功");
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (typeof this.form_data.org_id != "number") {
            const pid_len = this.form_data.org_id.length;
            this.form_data.org_id = this.form_data.org_id[pid_len - 1];
          }
          this.submitting = true;
          if (!this.hasId) {
            //添加
            this.form_data.org_id = this.$props.org_id;
            this.$_invoke("cabinetManage_saveNewCabinet", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.form_data.id = this.$props.id;
            this.form_data.mobile = this.form_data.username;
            this.$_invoke("cabinetManage_saveUpdateCabinet", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>